import angular from 'angular';
import moment from 'moment-timezone';
import { schedule } from '../../utils';
import '../../services/area'
import { map } from 'lodash';
import '../../services/place';
import '../../services/notifications';
import '../../services/slot-per-time-range';

const module = angular.module('whyline.modals.program-capacity', [
    'whyline.services.area',
    'whyline.services.place',
    'whyline.services.notifications',
    'whyline.services.slotsPerTimeRange',
]);

const ProgramCapacityController = (
  $scope,
  areaId,
  $uibModalInstance,
  AreaService,
  $timeout,
  PlaceService,
  $translate,
  NotificationService,
  SlotsPerTimeRangeService,
) => {
  'ngInject';
  $scope.areas = [];
  $scope.selectedArea = {
      _id: '',
      label: ''
  };
  $scope.place = PlaceService.GetCurrent();
  AreaService.GetAllAsPromise().then(areas => {
    $timeout(() => {
        map(areas, area => $scope.areas.push({
          _id: area._id,
          label: area.label,
          appointmentsConfiguration: area.appointmentsConfiguration,
        }));
        if (areaId) {
          $scope.selectedArea = $scope.areas.find(area => area._id === areaId);
        }
      });
});
  $scope.hours = schedule.getHour();
  $scope.minutes = schedule.getMinutesByParam(1);
  $scope.minutes.pop();
  let today = new Date();
  $scope.advancedSlotConfiguration = {
    dateFrom: '',
    dateTo: '',
    areaId: '',
    capacity: 1
};
$scope.hourFrom = $scope.hours[0].hour;
$scope.hourTo =  $scope.hours[0].hour;
$scope.minutesFrom = $scope.minutes[0].minute;
$scope.minutesTo = $scope.minutes[0].minute;
$scope.date = {
    from: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
    to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
  };
  $scope.dateOptionsFrom = {
    formatYear: 'yy',
    minDate: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
    startingDay: 1,
  };

  $scope.dateOptionsTo = {
    formatYear: 'yy',
    minDate:  new Date(today.getFullYear(), today.getMonth(), today.getDate()),
    startingDay: 1,
  };
  $scope.placeUTCOffset = moment
  .tz($scope.place.timezone)
  .format('Z')
  .toString();
  $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
  $scope.format = $scope.formats[0];
  $scope.altInputFormats = ['M!/d!/yyyy'];

  $scope.datesIsOpen = {
    from: false,
    to: false,
  };

  $scope.cancel = () => {
    $uibModalInstance.close('cancel');
  };

  $scope.changeSelectedArea = (selectedArea) => {
      $scope.selectedArea = selectedArea;
  }

  $scope.dateChange = () => {
    $scope.dateOptionsTo = {
        formatYear: 'yy',
        minDate: $scope.date.from,
        startingDay: 1,
    };
    $scope.date.to = $scope.date.from;
}

  $scope.save = () => {
    const timeFrom = $scope.hourFrom + ':' + $scope.minutesFrom;
    const timeTo = $scope.hourTo + ':' + $scope.minutesTo;
    const dateFromWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.from, timeFrom, $scope.placeUTCOffset);
    const dateToWithTime = SlotsPerTimeRangeService.GetDateWithTimezone($scope.date.to, timeTo, $scope.placeUTCOffset);
    const momentFrom = moment(dateFromWithTime);
    const momentTo = moment(dateToWithTime);
    const timeNow = new Date().getHours().toString() + ':' + new Date().getMinutes().toString();
    const now = SlotsPerTimeRangeService.GetDateWithTimezone(new Date(), timeNow, $scope.placeUTCOffset);
    const momentNow = moment(now);
    $scope.advancedSlotConfiguration.dateFrom = dateFromWithTime;
    $scope.advancedSlotConfiguration.dateTo = dateToWithTime;
    $scope.advancedSlotConfiguration.areaId = $scope.selectedArea._id;
    if ($scope.advancedSlotConfiguration.areaId === '') {
        NotificationService.Warning($translate.instant('no_process_warning'));
        return false;
    }
    const diff = momentTo.diff(momentFrom, 'minutes');
    const duration = $scope.selectedArea.appointmentsConfiguration.duration;
    if (momentFrom.format('DD-MM-YYYY') !== momentTo.format('DD-MM-YYYY')) {
      NotificationService.Warning($translate.instant('diferent_days_warning'));
      return false;
    }
    if (diff <= 0) {
      NotificationService.Warning($translate.instant('diff_below_zero_warning'));
      return false;
  }
    if (diff < duration) {
      NotificationService.Warning($translate.instant('not_divisible_warning'));
      return false;
    }
    if ($scope.advancedSlotConfiguration.capacity === undefined) {
      NotificationService.Warning($translate.instant('capacity_too_high'));
      return false;
    }
    if ($scope.advancedSlotConfiguration.capacity < 1) {
        NotificationService.Warning($translate.instant('capacity_zero_warning'));
        return false;
    }
    const isDivisible = diff % duration;
    if (isDivisible !== 0) {
        NotificationService.Warning($translate.instant('not_divisible_warning'));
        return false;
    }
    const diffNow = momentTo.diff(momentNow, 'minutes');
    if (diffNow < 0) {
        NotificationService.Warning($translate.instant('date_smaller_than_now_warning'));
        return false;
    }

    SlotsPerTimeRangeService.Create($scope.advancedSlotConfiguration).then(data => {
        NotificationService.Success($translate.instant('changes_saved'));
        $uibModalInstance.close('cancel');
    })
  }
};

module.exports = module.controller('ProgramCapacityController', ProgramCapacityController);
